import { useMemo } from 'react';
import { useWatch } from 'react-hook-form';
import { DataGrid } from '@mui/x-data-grid';

import { goalColumns, GOALS_VISIBILITY } from './GoalColumn';
import { IGoalFormValues } from '@Router/GoalAndOperationalPlans/Containers/GoalAndOperationalPlansFormProvider/types';
import { mapGoals } from './utils';

type GoalTableProps = {
  planIndex: number;
};

const GoalTable = ({ planIndex }: GoalTableProps) => {
  const goals =
    useWatch({
      name: `companyValueIncreasePlans.valueUpPlans.${planIndex}.goals`,
    }) || ([] as IGoalFormValues[]);

  const goalRows = mapGoals(goals);
  const columns = useMemo(() => goalColumns(planIndex), [planIndex]);

  return (
    <DataGrid
      rows={goalRows ?? []}
      columns={columns}
      getRowHeight={() => 'auto'}
      disableColumnSorting
      initialState={{
        columns: {
          columnVisibilityModel: GOALS_VISIBILITY,
        },
      }}
    />
  );
};
export default GoalTable;
